import query from '../constants/query';

export default {
    computed: {
        query() {
            return {
                ...query,
                ...this.$route.query
            };
        }
    }
};
